import { useTranslation } from 'react-i18next';

const renderProjects = [
  {
    id: 1,
    image: 'https://static.readdy.ai/image/1c1efe20ab982279d0e71dac7f6c0a80/6fc59a63a5f48d9830308d1d30bea814.jpeg',
    titleKey: 'modernLiving',
  },
  {
    id: 2,
    image: 'https://public.readdy.ai/ai/img_res/89786662ece6331c22e4aa80bdc2718f.jpg',
    titleKey: 'contemporary',
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=beautiful%20three%20dimensional%20architectural%20visualization%20of%20luxury%20modern%20kitchen%20interior%20design%20sleek%20white%20cabinets%20marble%20countertops%20stainless%20appliances%20natural%20light%20photorealistic%20rendering%20professional%20quality%20detailed%20visualization&width=600&height=400&seq=render-003&orientation=landscape',
    titleKey: 'luxuryKitchen',
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=impressive%20photorealistic%20three%20dimensional%20render%20of%20modern%20office%20space%20interior%20design%20contemporary%20workspace%20elegant%20furniture%20natural%20lighting%20clean%20minimalist%20aesthetic%20professional%20architectural%20visualization%20high%20quality%20detailed%20rendering&width=600&height=400&seq=render-004&orientation=landscape',
    titleKey: 'officeSpace',
  },
];

const completedProjects = [
  {
    id: 1,
    image: 'https://static.readdy.ai/image/1c1efe20ab982279d0e71dac7f6c0a80/9b8eec69e257236918c7dec102d47eff.jpeg',
    titleKey: 'cafeBarista',
  },
  {
    id: 2,
    image: 'https://static.readdy.ai/image/1c1efe20ab982279d0e71dac7f6c0a80/c560ed67ba7b2d7990e0c1d489477b7c.jpeg',
    titleKey: 'supermercado',
  },
  {
    id: 3,
    image: 'https://static.readdy.ai/image/1c1efe20ab982279d0e71dac7f6c0a80/ed79d9f297199423d2c17288cff1bed5.jpeg',
    titleKey: 'coliving',
  },
  {
    id: 4,
    image: 'https://static.readdy.ai/image/1c1efe20ab982279d0e71dac7f6c0a80/dc350ef74c13d85dae8009c0922958f5.jpeg',
    titleKey: 'luxuryTerrace',
  },
];

export default function RenderService() {
  const { t } = useTranslation();

  const processSteps = [
    {
      number: '01',
      title: t('common:renderService.steps.send.title'),
      description: t('common:renderService.steps.send.description'),
      icon: 'ri-upload-cloud-line',
    },
    {
      number: '02',
      title: t('common:renderService.steps.design.title'),
      description: t('common:renderService.steps.design.description'),
      icon: 'ri-pencil-ruler-2-line',
    },
    {
      number: '03',
      title: t('common:renderService.steps.delivery.title'),
      description: t('common:renderService.steps.delivery.description'),
      icon: 'ri-file-download-line',
    },
  ];

  const priceRanges = t('common:renderService.priceRanges', { returnObjects: true }) as Array<{
    range: string;
    description: string;
  }>;

  return (
    <>
      <section id="render-service" className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          {/* Header */}
          <div className="text-center mb-16">
            <h2 className="font-serif text-4xl md:text-5xl text-[#2B2B2B] mb-6">
              {t('common:renderService.title')}
            </h2>
            <p className="text-lg text-gray-700 max-w-4xl mx-auto leading-relaxed">
              {t('common:renderService.description')}
            </p>
          </div>

          {/* How It Works */}
          <div className="mb-20">
            <h3 className="font-serif text-3xl text-[#2B2B2B] text-center mb-12">
              {t('common:renderService.howItWorks')}
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {processSteps.map((step) => (
                <div
                  key={step.number}
                  className="relative bg-[#F5F5F0] rounded-2xl p-8 hover:shadow-xl transition-shadow"
                >
                  {/* Number Badge */}
                  <div className="absolute -top-4 -left-4 w-16 h-16 bg-[#8B9B7E] rounded-full flex items-center justify-center text-white font-bold text-xl shadow-lg">
                    {step.number}
                  </div>

                  {/* Icon */}
                  <div className="w-16 h-16 flex items-center justify-center mb-6 mt-4">
                    <i className={`${step.icon} text-5xl text-[#8B9B7E]`}></i>
                  </div>

                  {/* Content */}
                  <h4 className="text-xl font-semibold text-[#2B2B2B] mb-3">
                    {step.title}
                  </h4>
                  <p className="text-gray-600 leading-relaxed">
                    {step.description}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Pricing */}
          <div className="mb-20 bg-[#2B2B2B] rounded-3xl p-12">
            <h3 className="font-serif text-3xl text-white text-center mb-4">
              {t('common:renderService.pricing')}
            </h3>
            <p className="text-white/80 text-center mb-12 max-w-3xl mx-auto">
              {t('common:renderService.pricingDescription')}
            </p>

            {/* Price Range Grid */}
            <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-12">
              {priceRanges.map((item, index) => (
                <div
                  key={index}
                  className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center hover:bg-white/20 transition-colors"
                >
                  <div className="text-2xl font-bold text-white mb-2">
                    {item.range}
                  </div>
                  <div className="text-sm text-white/70">
                    {item.description}
                  </div>
                </div>
              ))}
            </div>

            {/* Contact Info */}
            <div className="text-center space-y-3">
              <p className="text-white font-semibold mb-4">{t('common:renderService.getInTouch')}</p>
              <div className="flex flex-wrap justify-center gap-6">
                <a
                  href="mailto:art.throng@gmail.com"
                  className="flex items-center space-x-2 text-white/90 hover:text-white transition-colors"
                >
                  <i className="ri-mail-line text-xl"></i>
                  <span>art.throng@gmail.com</span>
                </a>
                <a
                  href="tel:+34643939427"
                  className="flex items-center space-x-2 text-white/90 hover:text-white transition-colors"
                >
                  <i className="ri-phone-line text-xl"></i>
                  <span>+34 643 939 427</span>
                </a>
              </div>
            </div>
          </div>

          {/* Rendered Projects Gallery */}
          <div>
            <h3 className="font-serif text-3xl text-[#2B2B2B] text-center mb-12">
              {t('common:renderService.renderedProjects')}
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {renderProjects.map((project) => (
                <div
                  key={project.id}
                  className="group relative h-80 rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-shadow"
                >
                  <div className="w-full h-full">
                    <img
                      src={project.image}
                      alt={t(`common:renderService.projects.${project.titleKey}`)}
                      className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                    />
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center pb-6">
                    <p className="text-white font-semibold text-lg">
                      {t(`common:renderService.projects.${project.titleKey}`)}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Projects Completed Section */}
      <section className="py-24 bg-[#F5F5F0]">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="font-serif text-4xl md:text-5xl text-[#2B2B2B] mb-6">
              {t('common:projectsCompleted.title')}
            </h2>
            <p className="text-lg text-gray-700 max-w-3xl mx-auto leading-relaxed">
              {t('common:projectsCompleted.subtitle')}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {completedProjects.map((project) => (
              <div
                key={project.id}
                className="group relative h-96 rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all"
              >
                <div className="w-full h-full">
                  <img
                    src={project.image}
                    alt={t(`common:projectsCompleted.projects.${project.titleKey}`)}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent flex flex-col items-center justify-end pb-8">
                  <h3 className="text-white font-serif text-2xl mb-2 text-center px-4">
                    {t(`common:projectsCompleted.projects.${project.titleKey}`)}
                  </h3>
                  <div className="flex items-center space-x-2 text-white/90">
                    <i className="ri-map-pin-line text-lg"></i>
                    <span className="text-sm">{t('common:projectsCompleted.location')}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
